import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

/** The detail pane's way back to "nothing selected" (card 01b22bf7). Esc does the same. */
export default function VaultDetailClose({ onClose }) {
  const { t } = useTranslation();
  const label = t('vault.closeDetail', 'Close (Esc)');
  return (
    <button type="button" className="vault-action-btn" title={label} aria-label={label} onClick={onClose}>
      <X size={14} />
    </button>
  );
}
